// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3l8h8","unreadBadge":"styles_unreadBadge__1BBUJ","modalContent":"styles_modalContent__2ulxS","modal":"styles_modal__kkJXR"};